import { exceptionEffectFields } from './constants'

export const hasExceptionEffect = exception => exceptionEffectFields.some(field => exception[field])
